// ----------------------------------------------------------------------------
// Product Form Web Component: iamProductGallery <iam-product-gallery>
// Extends: iamFormElement
// ----------------------------------------------------------------------------
// Parent component responsible for managing the product media gallery.
// ----------------------------------------------------------------------------
// Customization:
// - Enable `featureSlider` to add a slider to the gallery.
// - Enable `productZoom` to add zoom functionality to the gallery.
// - Enable `productVideo` to add video functionality to the gallery.
// ----------------------------------------------------------------------------
// Event Triggers:
// - `productForm:gallery:init` → Fired when the gallery is initialized to allow
//                                other modules to hook in.
// ----------------------------------------------------------------------------
// Gotchas:
// - `sectionId` is extracted from `data-section-id`, ensure it's set correctly
//   on the component
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Helpers
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import iamFormElement from 'scripts/classes/iamFormElement';

// Styles
import './_product-gallery.scss';

// Modules
import './modules/productVideo';
import './modules/featureSlider';
import './modules/productZoom';

// -------------------------------------
// Web Component
// -------------------------------------

class iamProductGallery extends iamFormElement {
  /**
   * Initialize the component when the product form is initialized
   */
  onFormInit() {
    // Variables
    this.sectionId = this.dataset.sectionId;

    // Initialize modules
    iamotaEventHandler.trigger('productForm:gallery:init', {
      iamProductGallery: this
    }, {
      context: this
    });
  }
}

// Define the custom element
customElements.define('iam-product-gallery', iamProductGallery);